// extracted by mini-css-extract-plugin
export default {"toggleButtonDisabled":"styles_toggleButtonDisabled__l+7nP","square":"styles_square__W4w94","dashedSquare":"styles_dashedSquare__WBI0m"};